module.exports = __webpack_public_path__ + "img/gr.030431b8.svg";